import React, { createContext, useContext, useState, useEffect } from 'react';

const AIFilterContext = createContext();

export const useAIFilter = () => {
  const context = useContext(AIFilterContext);
  if (!context) {
    throw new Error('useAIFilter must be used within an AIFilterProvider');
  }
  return context;
};

export const AIFilterProvider = ({ children }) => {
  const [hideAIContent, setHideAIContent] = useState(() => {
    const saved = localStorage.getItem('socyy_hide_ai_content');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem('socyy_hide_ai_content', hideAIContent.toString());
  }, [hideAIContent]);

  const toggleAIFilter = () => {
    setHideAIContent(prev => !prev);
  };

  return (
    <AIFilterContext.Provider value={{ hideAIContent, setHideAIContent, toggleAIFilter }}>
      {children}
    </AIFilterContext.Provider>
  );
};

export default AIFilterContext;
